<template>
    <div>
        <div class="logo_div">
            <div class="logo_title">京东 · 万品京选</div>
        </div>
        <div style="padding: 5%">
            <!--        <h1 style="text-align: center;margin-top: 50px">-->
            <!--            <wp_img src="images/icon_3.png" type="app" size="70px"> </wp_img>-->
            <!--            <div>万品精选</div>-->
            <!--        </h1>-->

            <divider>超级会员登录</divider>
            <van-cell-group style="margin-top: 5%">
                <div class="login_input_div">
                    <van-field
                            class="login_input"
                            label-width="70px"
                            v-model="username"
                            label="用户名"
                            placeholder="请输入用户名"
                            required
                            clearable
                            right-icon="manager"
                    ></van-field>
                </div>

                <div class="login_input_div">
                    <van-field
                            class="login_input"
                            label-width="70px"
                            v-model="password"
                            type="password"
                            label="密码"
                            placeholder="请输入登录密码"
                            required
                            clearable
                            right-icon="lock"
                    ></van-field>
                </div>
            </van-cell-group>
            <div v-if="msg">
                <!--            <span style="color:red">{{msg}}</span>-->
            </div>
            <!--        <wp_hr></wp_hr>-->
            <van-button style="margin-top: 10%; border-radius:4px" @click="login(null)" type="danger" size="large">登录
            </van-button>
        </div>
    </div>
</template>

<script>
    import {Dialog} from 'vant';

    export default {
        name: "Wp_mini_super_login",

        data() {
            return {
                username: '',
                password: '',
                msg: '',
            }
        },
        methods: {
            login(fn) {
                let _userData = {
                    uname: this.username,
                    upwd: this.password,
                };
                if (_userData.uname && _userData.upwd) {

                    this.$login(_userData, response=> {
                        this.$log(response);
                        let code = response.code;
                        if (code === 200) {
                            let loginInfo = response.data[0];
                            let user = {
                                username: loginInfo.u_name,
                                userId: loginInfo.id,
                                pid: loginInfo.u_pid,
                                alipay: loginInfo.u_alpay,//支付宝账号
                                bankName: loginInfo.u_bank,//开户行
                                cardNomber: loginInfo.u_card,//银行卡号
                                bank_account: loginInfo.u_bank_account,// 账号名称
                                openid: loginInfo.u_openid,//微信openid
                                truename: loginInfo.u_payname,// 真实姓名
                                userType: loginInfo.u_type,// 0群主1代理商
                            };
                            this.$store.commit('login', user);


                            let openid = this.$common.gloabl_wx_openid;
                            if(openid){

                                let save_userinfo_params = {
                                    open_id: openid,
                                    channel_name: loginInfo.u_name,
                                    channel_id: ""
                                };

                                //保存用户信息（小光）
                                this.$saveUserinfoToServer(save_userinfo_params, response=>{

                                    if(response && response.data){
                                        this.$log("数据保存成功")
                                        this.$getGloabl_WxUserinfo(openid, ()=>{
                                            this.$router.push("select");
                                        })
                                    }
                                });


                                let params = {
                                    uid: loginInfo.u_name,
                                    oid: openid,
                                };
                                //跟服务器同步openid（老王）
                                this.$syncUserOpenid(params, response2 => {
                                    if(response2.code === 200){
                                        //同步成功，通过openid从服务器获取微信小程序用户信息
                                        // this.$getGloabl_WxUserinfo(openid, ()=>{
                                        //     this.$router.push("select");
                                        // })
                                        this.$log("openid同步成功")
                                    }
                                });

                            }


                            if(fn){
                                fn("success");
                            }
                            //登录成功后，刷新页面
                            // that.$emit('reload');
                        } else {
                            this.msg = response.msg;
                            Dialog({message: this.msg});
                        }
                    })
                } else {
                    Dialog({message: "用户名或密码不能为空"});
                    let test = this.$store.state.test;
                    // test = "0987";
                    if (test === '0987') {
                        let user = {
                            // username: "v156",//jd53256
                            // userId: "445",
                            // pid: "1825325610",
                            // alipay: "zfb_123456",//支付宝账号
                            // bankName: "",//开户行
                            // cardNomber: "",//银行卡号
                            // bank_account: "",// 账号名称
                            // openid: "",//微信openid
                            // truename: "王小二",// 真实姓名
                            // userType: 0,// 0群主1代理商
                            username: "xiaonian",//xiaoxiao
                            userId: "1042",
                            pid: "123456789",
                            alipay: "ww",//支付宝账号
                            bankName: "www",//开户行
                            cardNomber: "5676878898",//银行卡号
                            bank_account: "",// 账号名称
                            openid: "otyOg4ozV6nx9neuSClF0EQonk-Y",//微信openid
                            truename: "李晓楠",// 真实姓名
                            userType: 0,// 0群主1代理商
                        };
                        this.$store.commit('login', user);
                        //登录成功后，刷新页面
                        // this.$emit('reload');

                        let save_userinfo_params = {
                            open_id: "otyOg4ozV6nx9neuSClF0EQonk-Y",
                            channel_name: "S140",
                            channel_id: ""
                        };


                        this.$saveUserinfoToServer(save_userinfo_params, response=>{
                            this.$log(response)

                            this.$getGloabl_WxUserinfo("otyOg4ozV6nx9neuSClF0EQonk-Y", ()=>{
                                this.$router.push("select");
                            })
                        });


                    }
                }

            }
        }
    }
</script>

<style>
    .login_input_div {
        margin-top: 5%;
        padding: 2px;
        border-radius: 4px;
        border: 1px solid #E52212
    }

    .login_input {
        font-size: 17px
    }

    .logo_div {
        width: 100%;
        margin-top: -100px;
        height: 300px;
        background-color: #E52212;
        border-radius: 60px;

    }

    .logo_title{
        font-size: 40px;
        font-weight: bolder;
        color:white;
        position: absolute;
        width: 100%;
        text-align: center;
        margin-top: 170px;
    }
</style>
